import { render, staticRenderFns } from "./quote.vue?vue&type=template&id=10ae2cbc&"
import script from "./quote.js?vue&type=script&lang=js&"
export * from "./quote.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports